import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { post, Token } from '../../../../Script/Session';
import NavigationBar from '../../../../components/Navigationbar/Navigationbar';
import { Tab, tabClasses, TabList, TabPanel, Tabs, Typography } from '@mui/joy';
import LastTarif from './components/LastTarif';
import CreateFirstTarif from './components/CreateFirstTarif';
import TarifStände from './Tarifstände/TarifStände';
import Status from './Panels/Status';
import Verantwortlichetarif from './Panels/Verantwortlichetarif';
import EditTarif from './Panels/EditTarif';

function Tarif() {
  const navigate = useNavigate();
  const { id, overkath } = useParams();
  const [data, setdata] = useState("");
  const [wit, setwith] = useState("90.5%");
  const [index, setIndex] = React.useState(0);
  const [createfirsttarif, setcreatefirsttarif] = useState(false);
  useEffect(() => {
    const fetchVereinData = async () => {
      const body = {
        token: Token.get(),
        action: "get_tarif",
        targettarif: Number(id),
        subkathid: Number(overkath),
      };

      try {
        let response = await post(body, "/tarife/general");
        if (response === "LOGOUT") {
          navigate("/");
          return;
        }

        setdata(JSON.parse(response));
        console.log("Debug!! " + response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    setTimeout(() => {
      fetchVereinData();
    }, 15);

  }, [navigate]);



  function update() {
    const body = {
      token: Token.get(),
      action: "get_tarif",
      targettarif: Number(id),
      subkathid: Number(overkath),
    };

    try {
      let response = post(body, "/tarife/general");
      if (response === "LOGOUT") {
        navigate("/");
        return;
      }

      setdata(JSON.parse(response));
      console.log("Debug!! " + response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }





  return (
    <>
      <>
        <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", backgroundColor: "white", height: "100vh", display: "flex", alignItems: "center" }}>
          <Tabs
            aria-label="Pipeline"
            value={index}
            onChange={(event, value) => {
              if (value == 5){
                //navigate("/page-history" + "/tarif_" + data.id);
              }
              setIndex(value)
            }}
            sx={{ mt: 0, width: "100%", height: "100vh" }}
          >
            <TabList
              sx={{
                pt: 1,
                justifyContent: 'center',
                [`&& .${tabClasses.root}`]: {
                  flex: 'initial',
                  bgcolor: 'transparent',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                  [`&.${tabClasses.selected}`]: {
                    color: 'primary.plainColor',
                    '&::after': {
                      height: 2,
                      borderTopLeftRadius: 3,
                      borderTopRightRadius: 3,
                      bgcolor: 'primary.500',
                    },
                  },
                },
              }}
            >

              <Tab
                variant="soft"
                color="neutral">Aktueller Tarifstand</Tab>
              <Tab
                variant="soft"
                color="neutral">Status</Tab>
              <Tab
                variant="soft"
                color="neutral">Verantwortliche</Tab>
              <Tab
                variant="soft"
                color="neutral">Tarifstände</Tab>
              <Tab
                variant="soft"
                color="neutral">Bearbeiten</Tab>
            </TabList>
            <TabPanel sx={{ overflowY: "auto", p: 0 }} value={0}>{!createfirsttarif ? <LastTarif data={data} setcreate={setcreatefirsttarif} /> : <CreateFirstTarif setfirsttarif={setcreatefirsttarif} data={data} />}</TabPanel>
            {
              data && data.lasttarif && (
                <TabPanel value={1}><Status data={data} update={update} /></TabPanel>

              )
            }
            {
              data && data.lasttarif && (
                <TabPanel value={2}><Verantwortlichetarif data={data} updates={update} /></TabPanel>

              )
            }
            {
              data && data.lasttarif && (
                <TabPanel value={3} sx={{ p: 0 }}><TarifStände data={data} update={update} /></TabPanel>

              )
            }
            {
              data && data.lasttarif && (
                <TabPanel value={4} sx={{ p: 0 }}>{data && data.editperms ? (<EditTarif data={data} update={update}/>) : (<Typography sx={{color: "red"}}>Keine Berechtigung</Typography>)}</TabPanel>

              )
            }
          </Tabs>





        </div>
        <NavigationBar state={"vergleiche"} back={true} />
      </>
    </>
  )
}

export default Tarif
